import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const ORDER_DOCUMENT_UPLOAD_ERROR = "We couldn't process your document. Please check that the file is a supported format, within the size limit, and uploaded successfully before proceeding to checkout.";
export const ORDER_DOCUMENT_REQUIRED_ERROR = 'Please upload a purchase order or invoice before proceeding to checkout.';

@Injectable({ providedIn: 'root' })
export class GenOrderDocumentErrorService {
  private errorSubject = new BehaviorSubject<string | null>(null);
  readonly error$ = this.errorSubject.asObservable();

  showUploadError(): void {
    this.errorSubject.next(ORDER_DOCUMENT_UPLOAD_ERROR);
  }

  showRequiredError(): void {
    this.errorSubject.next(ORDER_DOCUMENT_REQUIRED_ERROR);
  }

  clear(): void {
    this.errorSubject.next(null);
  }
}
